import _ from 'lodash';
import api from '@/api';
import { DateTime } from 'luxon';

import FileDownload from 'js-file-download';

export default {
    namespaced: true,
    state: {
        elections: [],
        csvProgress: 0,
    },
    getters: {
        elections: state => state.elections,
        csvProgress: state => state.csvProgress,
    },
    mutations: {
        SET_CSV_STATUS(state, csvStatus) {
            state.csvProgress = csvStatus.progress;
        },
        SET_ELECTIONS(state, elections) {
            state.elections = elections.map(election => {
                election.start_date = DateTime.fromISO(
                    election.start_date
                ).toLocaleString(DateTime.DATETIME_MED);
                election.end_date = DateTime.fromISO(
                    election.end_date
                ).toLocaleString(DateTime.DATETIME_MED);
                return election;
            });
        },
    },
    actions: {
        getElections: ({ commit }, { start, end, type }) => {
            return new Promise(async function(resolve, reject) {
                try {
                    const response = await api.get(
                        '/reports/statistics/elections',
                        {
                            params: {
                                start,
                                end,
                                type,
                            },
                        }
                    );

                    if (
                        (response.status !== 200 && response.data) ||
                        response.data.status === 'error'
                    ) {
                        return reject(
                            response.data.reason || 'Ha ocurrido un error'
                        );
                    }

                    commit(
                        'SET_ELECTIONS',
                        _.get(response, 'data.elections', [])
                    );
                    resolve(_.get(response, 'data.elections', []));
                } catch (error) {
                    reject(error);
                }
            });
        },
        getStatistics: (
            { commit },
            { start, end, type, electionIds, token }
        ) => {
            return new Promise(async function(resolve, reject) {
                try {
                    const response = await api.get(
                        '/reports/statistics/voters',
                        {
                            params: {
                                start,
                                end,
                                type,
                                electionIds,
                                token,
                            },
                        }
                    );

                    if (
                        (response.status !== 200 && response.data) ||
                        response.data.status === 'error'
                    ) {
                        return reject(
                            response.data.reason || 'Ha ocurrido un error'
                        );
                    }

                    resolve(_.get(response, 'data.csv', ''));
                } catch (error) {
                    reject(error);
                }
            });
        },

        getCounselors: (
            { commit },
            { start, end, type, electionIds, token }
        ) => {
            return new Promise(async function(resolve, reject) {
                try {
                    const response = await api.get('/reports/counselors', {
                        params: {
                            start,
                            end,
                            type,
                            electionIds,
                            token,
                        },
                    });

                    if (
                        (response.status !== 200 && response.data) ||
                        response.data.status === 'error'
                    ) {
                        return reject(
                            response.data.reason || 'Ha ocurrido un error'
                        );
                    }
                    resolve(_.get(response, 'data.csv', ''));
                } catch (error) {
                    reject(error);
                }
            });
        },

        getWinners: ({ commit }, { start, end, type, electionIds, token }) => {
            return new Promise(async function(resolve, reject) {
                try {
                    const response = await api.get('/reports/winners', {
                        params: {
                            start,
                            end,
                            type,
                            electionIds,
                            token,
                        },
                    });

                    if (
                        (response.status !== 200 && response.data) ||
                        response.data.status === 'error'
                    ) {
                        return reject(
                            response.data.reason || 'Ha ocurrido un error'
                        );
                    }
                    resolve(_.get(response, 'data.csv', ''));
                } catch (error) {
                    reject(error);
                }
            });
        },

        getStatisticsResults: (
            { commit },
            { start, end, type, electionIds, token }
        ) => {
            return new Promise(async function(resolve, reject) {
                try {
                    const response = await api.get('/statistics/results', {
                        params: {
                            start,
                            end,
                            type,
                            electionIds,
                            token,
                        },
                    });

                    if (
                        (response.status !== 200 && response.data) ||
                        response.data.status === 'error'
                    ) {
                        return reject(
                            response.data.reason || 'Ha ocurrido un error'
                        );
                    }
                    resolve(_.get(response, 'data.csv', ''));
                } catch (err) {
                    reject(err);
                }
            });
        },
        generateCsv: ({ commit }, info) => {
            console.log('generateCsv');
            const fileName = info.name;
            const data = new Blob([info.csv], { type: 'text/csv' });
            FileDownload(data, fileName + '.csv');
        },
    },
};
